// extracted by mini-css-extract-plugin
export default {"ErrorCont":"ErrorPopup_ErrorCont__xmvP8","errorInOut":"ErrorPopup_errorInOut__hyw76"};